<template lang="pug">
.rest-table
  .rest-table__filters-wrapper
    slot(
      name="filters"
      v-bind="{ updateFilters, filters }"
    )
  DataTable(
    :embed="embed"
    :progress="isLoading"
    :headers="headers"
    :items="items"
    :sortBy="filters.sort_by"
    :sortOrder="filters.sort_order"
    :page="Number(filters.page)"
    :perPage="Number(filters.per_page)"
    :perPageOptions="perPageOptions"
    :totalItems="totalItems"
    :disablePagination="disablePagination"
    :stickyHeader="stickyHeader"
    :itemsPerPageAttachDropdownToBody="itemsPerPageAttachDropdownToBody"
    :filters="filters"
    :updateFilters="updateFilters"
    :error="error"
    :errorDetailsMessage="errorDetailsMessage"
    @sort="onSort"
    v-bind="$attrs"
  )
    template(
      v-for="header in headers"
      v-slot:[`cell:${header.key}`]="props"
    )
      slot(
        :name="`cell:${header.key}`"
        v-bind="props"
      )
</template>

<script>
import { defineComponent } from "vue";
import { useRestTable } from "./use-rest-table";

export default defineComponent({
  props: {
    namespace: {
      type: String,
      required: true,
    },

    embed: {
      type: Boolean,
      default: false,
    },

    headers: {
      type: Array,
      required: true,
    },

    perPageOptions: {
      type: Array,
      default: undefined,
    },

    fetchHandler: {
      type: Function,
      required: true,
    },
    disablePagination: {
      type: Boolean,
      default: false,
    },
    stickyHeader: {
      type: Boolean,
      default: true,
    },
    /** - this prop is used to make the perPage accessible in sticky footer
     * because attached to body has an auto detection for openDirection
     * - should be false for modals
     * */
    itemsPerPageAttachDropdownToBody: {
      type: Boolean,
      default: true,
    },
    initialFilters: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props) {
    const {
      isLoading,
      error,
      errorDetailsMessage,
      items,
      totalItems,
      filters,
      fetchData,
      updateFilters,
      onSort,
      getTableFilters,
    } = useRestTable(props);

    return {
      isLoading,
      error,
      errorDetailsMessage,
      items,
      totalItems,
      filters,
      fetchData,
      updateFilters,
      onSort,
      getTableFilters, // for external usage through the $ref
    };
  },
});
</script>

<style lang="scss">
.rest-table__filters-wrapper {
  margin-bottom: 16px;
}
</style>
